// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"55cced18","802":"25c8b5ba"}[chunkId] + ".chunk.js";
};